import { __assign, __awaiter, __generator } from "tslib";
import { APP_VERSION, IS_IOS, IS_ANDROID, IS_APP, IS_RN } from '../constants';
import { native } from '..';
import { canExecute } from '../utils/appVersion';
import { API_CONFIG, API_NAME_MAP } from '../config';
import { showToast } from './toast';
import logger from '../lib/logger';
var callbackCreator = function (apiName, callback) { return function (value, resValue) {
    try {
        var resData = {};
        if (resValue && typeof resValue === 'string') {
            try {
                resValue = JSON.parse(resValue);
                if (resValue.code) {
                    resValue.code = Number(resValue.code);
                }
                Object.assign(resData, resValue);
            }
            catch (error) { }
        }
        if (value && typeof value === 'string') {
            value = JSON.parse(value);
            Object.assign(resData, value);
        }
        try {
            callback === null || callback === void 0 ? void 0 : callback(resData);
        }
        catch (error) {
            logger.error(error.message);
        }
        return resData;
    }
    catch (e) {
        logger.error("bridge api(".concat(apiName, ") json parse fail"));
    }
    return null;
}; };
export var call = function (target, method, params, extraArgs) { return __awaiter(void 0, void 0, void 0, function () {
    var apiName, config, name, isUse, handler, handler_1;
    var _a;
    return __generator(this, function (_b) {
        apiName = "".concat(target, "_").concat(method);
        config = API_CONFIG[apiName];
        name = ((_a = config === null || config === void 0 ? void 0 : config.apiName) === null || _a === void 0 ? void 0 : _a[0]) || '';
        isUse = canIUse(name, true);
        if (!isUse)
            return [2 /*return*/, Promise.resolve(void 0)];
        if (native.callbackIdMap[apiName]) {
            if (typeof params !== 'function')
                throw new Error("bridge api(".concat(apiName, ") params is not function"));
            handler = callbackCreator(apiName, params);
            native.postMessage(target, method, __assign({}, extraArgs), handler);
            return [2 /*return*/, Promise.resolve(void 0)];
        }
        else {
            handler_1 = callbackCreator(apiName);
            return [2 /*return*/, new Promise(function (resolve) {
                    native.postMessage(target, method, params, function (value, resValue) {
                        var val = handler_1(value, resValue);
                        if (val === null)
                            resolve(value);
                        else
                            resolve(val);
                    });
                })];
        }
        return [2 /*return*/];
    });
}); };
export var canIUse = function (name, showTip) {
    if (IS_APP) {
        var config = API_NAME_MAP[name];
        if (config) {
            var version = config.version, ignoreToast = config.ignoreToast;
            var apiVersion = '';
            if (IS_IOS)
                apiVersion = version.ios;
            if (IS_ANDROID)
                apiVersion = version.android;
            if (apiVersion) {
                if (!canExecute(APP_VERSION, apiVersion)) {
                    if (showTip && !ignoreToast)
                        showToast('当前版本过低，请前往【设置-关于森空岛】检查更新');
                    return false;
                }
                return true;
            }
            else {
                logger.error("unknown app system");
                return false;
            }
        }
        else {
            if (showTip)
                showToast('当前功能暂不支持，请联系客服人员反馈');
            logger.error("unknown bridge api(".concat(name, ")"));
            return false;
        }
    }
    else if (IS_RN) {
        logger.error("unknown bridge api(".concat(name, ")"));
        return false;
    }
    else {
        return true;
    }
};
